import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CommentFormModel, CommentsData, ComplaintComment } from '../../../../models/CommentsData';
import { ComplaintsTicktsService } from '../../../../services/complaintsTickts.service';

@Component({
  selector: 'app-complaint-comment-controls',
  standalone: false,
  templateUrl: './complaint-comment-controls.component.html'
})
export class ComplaintCommentControlsComponent implements OnInit, OnChanges, AfterViewInit {
  formGroup!: FormGroup;
  commentForWhomsList: any[] = [];
  @Input({ required: true }) recordId!: number
  @Input() selectedRecord!: ComplaintComment | null;
  @Input() isReplay!: boolean
  @Output() submitComment = new EventEmitter()
  @Output() cancelEdit = new EventEmitter()
  @ViewChild('autoInput') autoInput!: ElementRef;


  constructor(
    private service: ComplaintsTicktsService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
  ) {
    this.buildForm();

  }
  ngOnInit(): void {
    this.getDisplayCommentForWhoms();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes && changes['selectedRecord']
      && changes['selectedRecord'].currentValue
      && this.formGroup
      && ((!this.isReplay && !this.selectedRecord?.isReply) || (this.isReplay && (this.selectedRecord?.isReply || !this.selectedRecord)))
    ) {
      this.formGroup.controls['comment'].setValue(changes['selectedRecord'].currentValue.comment)
      this.formGroup.controls['sendCommentTo'].setValue(this.isReplay ? null : changes['selectedRecord'].currentValue.sendTo[0].code)
    }
  }

  ngAfterViewInit(): void {
    // this.autoInput.nativeElement.focus();
  }

  getDisplayCommentForWhoms() {
    this.service
      .getDisplayCommentForWhoms(this.recordId)
      .subscribe((res: any) => {
        this.commentForWhomsList = res;
      });
  }

  buildForm(value = null) {
    this.formGroup = this.formBuilder.group({
      comment: [value ? value : null, Validators.required],
      sendCommentTo: [null],
    });
  }

  submit() {
    if (this.formGroup.valid) {
      this.submitComment.emit(this.formGroup.value)
      this.formGroup.controls['comment'].setValue(null);
      this.formGroup.controls['sendCommentTo'].setValue(null);
      this.selectedRecord = null
    }
  }

  cancel() {
    this.cancelEdit.emit(true)
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

}
